import(/* webpackMode: "eager" */ "/app/ui/app/global-error.tsx");
